// pages/ChatSwingsetPage.jsx
import React, { useEffect, useState } from "react";
import "./ChatSwingsetPage.css";
import ChatPanel from "../components/ChatPanel";

const BASE = (import.meta?.env?.BASE_URL ?? "/").replace(/\/+$/, ""); // works for Vite/CRA

export default function ChatSwingsetPage() {
  const [files, setFiles] = useState([]);
  const [selected, setSelected] = useState("");
  const [json, setJson] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${BASE}/fixtures/index.json`, {
          cache: "no-store",
        });
        if (!res.ok) throw new Error(`index.json ${res.status}`);
        const names = await res.json();
        if (!Array.isArray(names))
          throw new Error("index.json must be an array");
        setFiles(names);
        if (names[0]) load(names[0]);
      } catch (e) {
        setErr(String(e?.message || e));
      }
    })();
  }, []);

  async function load(name) {
    try {
      setErr("");
      setSelected(name);
      const res = await fetch(`${BASE}/fixtures/${name}`, {
        cache: "no-store",
      });
      if (!res.ok) throw new Error(`${name} ${res.status}`);
      setJson(await res.json());
    } catch (e) {
      setJson(null);
      setErr(String(e?.message || e));
    }
  }

  return (
    <div className="chat-swingset-page" style={{ padding: 16 }}>
      <h1 style={{ margin: 0 }}>ChatSwingsetPage</h1>
      <div className="fixture-row">
        {files.map((name) => (
          <button
            key={name}
            onClick={() => load(name)}
            className={`fixture-btn${selected === name ? " is-selected" : ""}`}
            title={name}
          >
            {name}
          </button>
        ))}
      </div>

      {err && <div style={{ color: "crimson", marginTop: 8 }}>{err}</div>}

      <section className="chat-swingset-host" style={{ marginTop: 12 }}>
        {json ? (
          <ChatPanel
            key={selected}
            // If a file contains an array of envelopes, render the first one.
            mockEnvelope={Array.isArray(json) ? json[0] : json}
          />
        ) : (
          <div style={{ color: "var(--lh-muted, #64748b)" }}>
            Pick a file to view its JSON.
          </div>
        )}
      </section>
    </div>
  );
}
